export enum AssetProviderGroupId {
  GETTY_IMAGES_ESSENTIAL = 'essentials',
}
